import { IUserInitialQuizData } from "@interfaces/initial-quiz/initial-quiz"
import { getUserInitialQuizData } from "@services/practitioner/initial-quiz"
import { useCallback, useEffect, useState } from "react"

/**
 * Retrieve user initial quiz data. This should be summed up in a single document
 * @param holdInit If true, the initial quiz data won't be loaded automatically, but it will be updated once the `updateInfo` promise is fulfilled
 * @returns 
 */
const useUserInitialQuiz = (holdInit?: boolean) => {
    const [ data, setData ] = useState<IUserInitialQuizData | null>(null)
    const [ error, setError ] = useState<unknown | null>(null)
    const [ isLoading, setIsLoading ] = useState<boolean>(true)

    const updateInfo = useCallback(async(override?: IUserInitialQuizData) => {
        if(override)
        {
            setData(override)
            return
        }

        setIsLoading(true)

        try
        {
            const resp = await getUserInitialQuizData()
            setData(resp)
            setError(null)
        }
        catch(err)
        {
            console.error("getUserInitialQuizData", err)
            setError(err)
        }
        finally
        {
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        if(!holdInit)
            updateInfo()
    }, [holdInit, updateInfo])

    return { data, error, isLoading, updateInfo }
}

export default useUserInitialQuiz
